import { getProfiles } from 'helpers/snapshot';
import { queryClient } from 'index';
import { ProposalResponse, ResultsResponse } from 'pages/ProposalDetail';
import { ProposalsResponse } from 'pages/Proposals';
import { useEffect, useRef } from 'react';
import { isEqual } from 'lodash';
import { RefetchOptions } from 'react-query';
import { Queries } from 'types/enum';

export function useAuthorProfiles(
  data: ProposalsResponse | undefined,
  proposalFilter: string,
  isLoading: boolean
) {
  useEffect(() => {
    if (!isLoading && data && data.proposals) {
      const { proposals, space } = data;
      getProfiles(proposals.map((v) => v.author)).then((author) => {
        const proposalResponse = queryClient.getQueryData<ProposalsResponse>([
          Queries.PROPOSALS,
          proposalFilter,
          space.id
        ]);
        const newProposalData = proposalResponse?.proposals.map((v) => {
          return {
            ...v,
            authorEns: author[v.author].ens ? author[v.author].ens : null
          };
        });
        const newResults = { ...proposalResponse, proposals: newProposalData };
        queryClient.setQueriesData(
          [Queries.PROPOSALS, proposalFilter, space.id],
          newResults
        );
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, data]);
}

export function useProfiles(
  proposal: ProposalResponse | undefined,
  results: ResultsResponse | undefined,
  refetch: (options?: RefetchOptions | undefined) => Promise<any>
) {
  const votersRef = useRef<any[]>();
  const resultsRef = useRef<any>();

  useEffect(() => {
    if (
      proposal?.proposal &&
      results?.results &&
      !isEqual(results.results, resultsRef.current)
    ) {
      // Get voters ens
      getProfiles(results.votes.map((v) => v.voter)).then((profiles) => {
        const resultsResponse = queryClient.getQueryData<ResultsResponse>([
          'results',
          proposal.proposal.id
        ]);
        const newVotesData = resultsResponse?.votes.map((v) => {
          return {
            ...v,
            voterEns: profiles[v.voter].ens ? profiles[v.voter].ens : null
          };
        });
        const newResults = { ...resultsResponse, votes: newVotesData };
        queryClient.setQueriesData(
          ['results', proposal?.proposal.id],
          newResults
        );
      });

      //  Set authors ens
      getProfiles([proposal.proposal.author]).then((author) => {
        const proposalResponse = queryClient.getQueryData<ProposalResponse>([
          'proposal',
          proposal.proposal.id
        ]);
        const newProposalData = {
          ...proposalResponse,
          proposal: {
            ...proposalResponse?.proposal,
            authorEns: author[proposal.proposal.author].ens
          }
        };
        queryClient.setQueriesData(
          ['proposal', proposal.proposal.id],
          newProposalData
        );
      });

      resultsRef.current = results.results;
    }
  }, [proposal, results]);

  useEffect(() => {
    if (proposal?.votes && !isEqual(proposal?.votes, votersRef.current)) {
      if (votersRef.current) {
        refetch();
      }
      votersRef.current = proposal?.votes;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [proposal?.votes]);
}
